import React from "react";
//images
import brLogo from "../../../assets/images/png/Logo@2x.png";
import hiEmoji from "../../../assets/images/png/hiEmojiLogin.png";
//components
import BrandLogo from "../../../components/common/BrandLogo/BrandLogo";
//css
import "./LoginHeader.css";
const LoginHeader = ({ infoText }) => {
  return (
    <div className="login_header_wrapper">
      <BrandLogo
        imgSrc={brLogo}
        imgAlt={"BrandLogo"}
        customClass={"brLogo"}
        imgSize={"14rem"}
      />

      <div className="header_text">
        <span className="flex">Welcome to bidZ.ai! </span>
        <p>{infoText}</p>
      </div>
    </div>
  );
};

export default LoginHeader;
